/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Controls how a customer receives the printout of a document and its attachments.
 */
export enum EnumPrintoutMergeStrategy {
    /**
     * All attachments are merged onto the primary document into a single PDF.
     */
    Merged = 0,
    /**
     * The primary document and its merged attachments are sent as two separate PDFs.
     */
    Separate = 1,
    /**
     * The primary document and every attachment are sent as individual files.
     */
    Individual = 2,
}
